import { IUpdateDiarioObraEquipamentoUseCase } from "../../../presentation/useCases/update/update_diario_obras_equipamento_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// UpdateDiarioObraEquipamentoUseCase


export class UpdateDiarioObraEquipamentoUseCase implements IUpdateDiarioObraEquipamentoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async updateDiarioObraEquipamento( IdDiarioObrasEquipamentos: number, IdDiarioObras: number | null, IdMaquinaEquip: number | null, Descricao: string | null, Tipo: string | null,  Quantidade: number | null): Promise<void> {
    
    await this.repository.updateDiarioObraEquipamento(
       IdDiarioObrasEquipamentos, IdDiarioObras, IdMaquinaEquip, Descricao, Tipo,  Quantidade
    );
  }
}
